export enum PermissionUserOption {
  USER_COMMON_FLAG_LOG_GRPC = 'pu_log_grpc_request',
  USER_COMMON_LOGIN = 'usuarios',
  USER_LIST = '/usuarios/lista',
  USER_CREATE = '/usuarios/crear',
  USER_ASSIGN_ROLE_AND_POINTS = '/usuarios/ver_puntos/',
  USER_ASSIGN_ROLE_AND_PERMISSIONS = '/usuarios/asignar-roles-permisos/',
  USER_ASSIGN_POINT = '/usuarios/asignar',
  USER_REASSIGN_POINT = '/usuarios/reasignar',
  USER_ACTIVE_ACTION = 'domi.user.activeAction',
  USER_INACTIVE_ACTION = 'domi.user.inactiveAction',
  USER_EDIT = 'domi.user.edit',
  USER_DELETE = 'domi.user.delete',
  USER_ASSIGN_ROLE = 'domi.user.associateRole',
  USER_SOCKET_FRONT = 'activate_socket_front',
}
